import {create} from 'zustand';

const addressStore = create((set) => ({
    addressAll: {
        items: [],
        total: 0,
        page: 0,
        size: 0,
        has_more: false
    },
    detailAddress: {},
    setDetailAddress: (detailAddress) => set({detailAddress}),
    setAddresses: (addressAll) => set({addressAll}),
}));

export default addressStore;
